import { render, staticRenderFns } from "./MenuClasses.vue?vue&type=template&id=dd9cd1c0&scoped=true&"
import script from "./MenuClasses.vue?vue&type=script&lang=js&"
export * from "./MenuClasses.vue?vue&type=script&lang=js&"
import style0 from "./MenuClasses.vue?vue&type=style&index=0&id=dd9cd1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9cd1c0",
  null
  
)

export default component.exports